var map = {
	"./cn": 171,
	"./cn.js": 171,
	"./en": 172,
	"./en.js": 172,
	"./index": 28,
	"./index.js": 28
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;



//////////////////
// WEBPACK FOOTER
// ./src/locale ^\.\/.*$
// module id = 252
// module chunks = 168707334958949